<template>
    <div class="cloud-wrap">
        <div class="cloud-main">
            <div class="cloud-fillter" :style="{ position: headTop }">
                <div class="cloud-fillter-inner flex">
                    <div>
                        <reo-select v-model="device" :options="[
                            {
                                label: this.$t( 'all_my_device' ),
                                value: '',
                                isShare: false
                            },
                            ...deviceList
                        ]">
                            <template slot="prefix" slot-scope="{option}">
                                <i v-if="option && option.isShare" class="share-icon icon-icon_share"></i>
                            </template>
                        </reo-select>
                    </div>
                    <div>
                        <datepicker v-model="date" :available="available" class="cloud-datepicker"></datepicker>
                    </div>
                </div>
                <div :class="['video-list-current-day', {'has-video': videoList.length !== 0, 'has-shadow': hasShadow}]">{{ currentDay }}</div>
            </div>
            <video-handle
            v-if="showExpiredLable"
            :isShare="isShare"
            :openSelecte="openSelecte"
            :selectedAll="selectedAll"
            :videoList="videoList"
            :showExpired="showExpired"
            :showExpiredLable="showExpiredLable"
            @openSelecteHandle="openSelecteHandle"
            @selectedAllHandle="selectedAllHandle"
            @showExpiredHanle="showExpiredHanle"
            @delete="deleteVideo"></video-handle>
            <reo-checkbox v-model="mobileShowExpired" v-if="showExpiredLable" :text="$t('cloud.showExpired')" class="mobile-show-expired" @click="showExpiredHanle"></reo-checkbox>
            <novideo v-if="videoList.length === 0 && showContent && !hasMore" :renewal="renewal"></novideo>
            <div class="video-list" v-if="videoList.length !== 0 && showContent">
                <video-list-item
                v-for="( video, index ) in videoList"
                :key="index"
                :index="index"
                :video="video"
                :device="device"
                :date="date"
                @delete="deleteVideo"
                @selectHandle="selectHandle"
                :showCheckbox="openSelecte"
                :deviceObj="deviceObj"/>
            </div>
            <pagination
            :total="count"
            :pageSize="cloudVideoPageUnit"
            :currentPage="page"
            @pageChange="goPage"
            v-show="videoList.length !== 0 && showContent"></pagination>
            <reo-dialog
            v-if="error"
            :labelOfConfirm="$t('cloud.error.refresh')"
            :labelOfCancel="$t('cloud.error.cancel')"
            :title="$t('cloud.error.title')"
            :description="$t('cloud.error.des')"
            @confirm="refresh"
            @cancel="cancel"
            ></reo-dialog>
        </div>
    </div>
</template>

<script>
import VideoListItem from '@/components/VideoListItem';
import ReoCheckbox from '@/basic/Checkbox';
import ReoSelect from '@/basic/Select';
import Datepicker from '@/basic/Datepicker';
import { getVideoList, getDeviceInfoHasVideo, getTimeMap, start, end } from '@/api/cloud';
import { resolveToTimestamp, timeResolve } from '@/common/js/date';
import VideoHandle from './VideoHandle';
import { config } from 'CONFIG';
import Novideo from './Novideo';
import Pagination from '@/basic/Pagination';
import ReoDialog from '@/basic/Dialog';
import router from '@/router';
import { orderedProductInfo } from '@/api/plan';
import { subscription as subscriptionStatus } from '@/config/status';

export default {

    components: {

        VideoListItem,
        Datepicker,
        ReoCheckbox,
        ReoSelect,
        Pagination,
        VideoHandle,
        Novideo,
        ReoDialog

    },

    async created () {

        this.scroll();

    },

    async mounted () {

        try {

            await this.getDeviceList();
            await this.getTimeMap();
            await this.getVideos();
            let sub = await orderedProductInfo();
            if ( this.videoList.length === 0 && !sub ) {

                router.push( '/user/subscribe-plan/' );

            }
            // 订阅已过期且没有视频
            if ( this.videoList.length === 0 && sub && sub.status !== subscriptionStatus.ACTIVE ) {

                if ( config.featrue.disabled.includes( 'library.renewal' )) {

                    this.renewal = true;
                
                } else {
                    
                    router.push( '/user/subscribe-plan/' );
                
                }

            }
            this.showExpiredLable = this.videoList.length > 0;

        } catch ( err ) {

            console.error( err );
            this.error = true;

        }
        this.showContent = true;
        if ( $( 'body' ).eq( 0 )[ 0 ].offsetWidth < 1200 ) {

            this.$nextTick(() => {

                this.calcCurrentDay();
                window.addEventListener( 'scroll', this.scrollHandle );

            });

        }

        window.addEventListener( 'scroll', this.scroll );

    },

    destroyed () {

        window.removeEventListener( 'scroll', this.scrollHandle );

    },

    data () {

        return {

            data: true,
            device: this.$route.query.device || '',
            page: 1,
            date: this.$route.query.date || 'All-All-All',
            count: 0,
            available: [],
            openSelecte: false,
            deviceList: [],
            deviceObj: {},
            videoList: [],
            hasMore: false,
            showContent: false,
            cloudVideoPageUnit: config.cloudVideoPageUnit,
            run: true,
            currentDay: '',
            hasShadow: false,
            error: false,
            headTop: false,
            showExpired: false,
            mobileShowExpired: false,
            showExpiredLable: false,
            // 是否是别人分享的设备
            isShare: false,
            deviceUid: this.$route.query.device || '',
            ownerId: '',
            // 订阅过期了，续费
            renewal: false

        };

    },

    methods: {

        async getVideos ( selected ) {

            try {

                let { total, videos } = await getVideoList({

                    device: this.deviceUid,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    page: this.page,
                    showExpired: this.showExpired,
                    owner: this.ownerId

                });
                if ( total !== 0 && videos.length === 0 && this.page !== 1 ) {

                    this.page -= 1;

                } else {

                    videos.forEach(( item ) => {

                        item.checked = false;

                    });
                    this.count = total;
                    this.videoList = videos;
                    this.hasMore = videos.length === config.cloudVideoPageUnit;
                    if ( !selected ) {

                        this.openSelecte = false;

                    }

                }

            } catch ( err ) {

                this.error = true;
                console.error( err );

            }

        },

        getDeviceList () {

            getDeviceInfoHasVideo().then( devices => {

                let deviceList = [];
                let deviceObj = {};
                devices.forEach(( device ) => {

                    if ( device.uid ) {

                        if ( device.sharedInfo ) {

                            let canShare = device.sharedInfo.channels[0].privileges.filter( item => {

                                return item.name.toLowerCase() === 'cloudvideo';

                            });
                            // 有被分享的设备且有权限
                            if ( canShare.length ) {

                                deviceList.push({
                                    status: device.status === 'associated' ? '' : 'unbound',
                                    uid: device.uid,
                                    label: `${device.title || device.uid} - ${device.sharedInfo.owner.nickName}`,
                                    value: `${device.sharedInfo.owner.nickName}-${device.uid}`,
                                    isShare: true,
                                    ownerId: device.sharedInfo.ownerId
                                });
                                deviceObj[ device.uid ] = device.title || device.uid;

                            }

                        } else {

                            deviceList.push({

                                status: device.status === 'associated' ? '' : 'unbound',
                                uid: device.uid,
                                label: device.title || device.uid,
                                value: device.uid,
                                isShare: false,
                                ownerId: ''

                            });
                            deviceObj[ device.uid ] = device.title || device.uid;

                        }

                    }

                });
                this.deviceList = [];
                this.deviceList = deviceList;
                console.log( this.deviceList );
                this.deviceObj = deviceObj;

            }).catch( err => {

                console.error( err );

            });

        },

        getTimeMap ( uid, owner ) {

            getTimeMap( uid, owner ).then( timeMap => {

                this.available = timeMap;

            }).catch( err => {

                console.error( err );

            });

        },

        openSelecteHandle ( openSelecte ) {

            if ( !openSelecte ) {

                this.selectedAllHandle( false );

            }
            this.openSelecte = openSelecte;

        },

        selectedAllHandle ( selectedAll ) {

            if ( selectedAll ) {

                this.openSelecte = selectedAll;

            }
            let videoList = this.videoList;
            videoList.forEach(( video ) => {

                video.checked = selectedAll;

            });

        },

        async goPage ( page ) {

            this.page = page;
            await this.getVideos();
            this.$nextTick(() => {

                if ( $( 'body' ).eq( 0 )[ 0 ].offsetWidth < 1200 ) {

                    this.calcCurrentDay();

                }
                window.scrollTo( 0, 0 );

            });

        },

        deleteVideo ( videoIDs ) {

            this.getVideos( true );

        },

        selectHandle ({ index, checked }) {

            this.$set( this.videoList[ index ], 'checked', checked );

        },

        scrollHandle () {

            if ( !this.run ) {

                return false;

            }
            this.run = false;
            setTimeout(() => {

                if ( $( 'body' ).eq( 0 )[ 0 ].offsetWidth < 1200 ) {

                    this.calcCurrentDay();

                }
                this.run = true;

            }, 100 );

        },

        calcCurrentDay () {

            let top = $( document ).scrollTop();
            let eHeight = $( '.video-list>.wrap' ).eq( 0 ).outerHeight( true );
            if ( $( '.video-list>.wrap' ).length === 0 ) {

                return false;

            }
            let videoList = this.videoList;
            let index = 0;
            let distance = top;
            let _index = Math.floor( distance / eHeight );
            if ( _index < 0 ) {

                index = 0;

            } else if ( 2 * _index > videoList.length - 1 ) {

                index = Math.floor(( videoList.length - 1 ) / 2 );

            } else {

                index = _index;

            }
            this.hasShadow = distance > 0;
            let {

                year,
                month,
                dateOfMonth
                // hourOf12Decimal: hour,
                // noon,
                // minute,
                // second

            } = timeResolve( videoList[ 2 * index ].createdAt );
            this.currentDay = `${dateOfMonth}/${month}/${year}`;
            // this.currentDay = `${dateOfMonth}/${month}/${year} ${hour}:${minute}:${second} ${noon}`;

        },

        refresh () {

            window.location.reload();

        },

        cancel () {

            this.error = false;

        },

        scroll () {

            let scroll = document.body.scrollTop || document.documentElement.scrollTop;

            if ( scroll >= 64 ) {

                this.headTop = 'fixed';

            } else {

                this.headTop = 'static';

            }

        },
        showExpiredHanle ( showExpired ) {

            this.showExpired = showExpired;
            if ( this.date === 'All-All-All' ) {

                this.goPage( 1 );

            } else {

                this.date = 'All-All-All';

            }

        }

    },

    computed: {

        startTime () {

            return resolveToTimestamp({

                date: this.date,
                rangeStart: start,
                rangeEnd: end

            }).start;

        },

        endTime () {

            return resolveToTimestamp({

                date: this.date,
                rangeStart: start,
                rangeEnd: end

            }).end;

        },

        selectedAll () {

            let videoList = this.videoList;
            let selectedAll = true;
            if ( videoList.length === 0 ) {

                selectedAll = false;

            } else {

                for ( let video of videoList ) {

                    if ( !video.checked ) {

                        selectedAll = false;
                        break;

                    }

                }

            }
            return selectedAll;

        }

    },

    watch: {

        async device ( device ) {

            try {

                // 是否是别人分享的设备
                let item = this.deviceList.filter( item => {

                    return item.value === device;

                });
                // 当选中所有 item[0] 为空
                this.ownerId = item[0] && item[0].ownerId;
                this.deviceUid = item[0] && item[0].uid;
                this.isShare = item[0] && item[0].isShare;
                await this.goPage( 1 );
                await this.getTimeMap( this.deviceUid, this.ownerId );

            } catch ( err ) {

                this.error = true;

            }

        },

        async date ( date ) {

            if ( this.showExpired && date !== 'All-All-All' ) {

                this.showExpired = false;

            }
            await this.goPage( 1 );

        },
        showExpired ( showExpired ) {

            this.mobileShowExpired = showExpired;

        }

    }

};
</script>

<style lang="less">
    .cloud-wrap{
        min-height: 6.5rem;
        .reo-select .reo-select-option li {
            padding: 0.18rem 0.16rem;
            text-align: left;
            span {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        .share-icon {
            font-size: 0.14rem;
        }
        @media screen and (max-width:1199px) {
            .reo-select .reo-select-option li {
                text-align: center;
            }
            .reo-select .reo-select-option li .share-icon {
                font-size: 0.22rem;
                padding-right: 0.08rem;
            }
        }
    }
    .cloud-main{
        background-color: #fff;
    }
    .cloud-fillter{
        background: #F3F4F9;
        height: .8rem;
    }
    .video-list{
        max-width: 12rem;
        margin: 0.2rem auto;
        text-align: left;
    }
    .cloud-fillter-inner{
        max-width: 600px;
        margin: auto;
        height: .8rem;
        align-items: center;
        box-sizing: border-box;
        display: flex;
        position: relative;
    }
    .video-list-current-day{
        display: none;
    }
    @media screen and (max-width:1199px) {
        .video-list-current-day.has-video{
            font-size: 0.3rem;
            display: block;
            width: 100%;
            line-height: 0.88rem;
            background-color: #fff;
            font-weight: 500;
            padding-left: 15px;
            z-index: 3;
            box-sizing: border-box;
        }
        .has-shadow.video-list-current-day.has-video{
            box-shadow: 0 0.06rem 0.3rem rgba(255, 255, 255, 0.1);
        }
        .video-list-current-day.has-video.hasShadow{
            box-shadow: 0 0.06rem 0.3rem rgba(255,255,255,.1);
        }
        .cloud-fillter-inner{
            max-width: 100%;
        }
        .cloud-fillter-inner:after{
            content: '';
            display: block;
            width: 1px;
            height: 0.4rem;
            border-left: 1px solid #ccc;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
    .cloud-fillter-inner>div{
        width:50%;
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        padding: 0.05rem 0;
    }
    .cloud-datepicker{
        display: inline-block;
    }
    @media screen and (max-width:1199px) {
        .video-list{
            padding: 0 15px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 0;
            padding-top: .3rem;
        }
    }
    .mobile-show-expired{
        padding: 0.88rem 15px 0;
        @media @pc{
            display: none !important;
        }
        .text{
            font-weight: 500;
        }
    }

</style>



// WEBPACK FOOTER //
// src/view/cloud/index.vue